import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// interface OAuthInputRequest {
//     sessionId?: string;
//     jwe?: string;
//     urlControleBackend: string;
//     origin: string;
// }

// interface TesteChamadaInputRequest {
//     jwt?: string;
//     urlControleBackend: string;
//     origin: string;
// }

@Component({
    standalone: false,
    selector: 'app-oauth',
    templateUrl: './oauth.component.html',
    styleUrls: ['./oauth.component.scss']
})
export class OAuthComponent {

    // nomeSessionId = "";
    // nomeJWE = "";
    // origin = "NOME";
    // originChamadaTeste = "DEFAULT";
    // urlGeracaoToken2 = "http://localhost:8080/issuer/oauth";
    // urlGeracaoToken = "https://carbon-credit-ingress-dev.internalenv.corp/issuer/oauth";
    // urlChamadaTeste2 = "http://localhost:8080/issuer/teste-chamada";
    // urlChamadaTeste = "https://carbon-credit-ingress-dev.internalenv.corp/issuer/teste-chamada";
    // urlControleBackend = "https://balcao-ms-dev.internalenv.corp";
    // tokenGerado = "";
    // respostaChamada: any = null;

    constructor(
        private activatedRoute: ActivatedRoute,
        private httpClient: HttpClient) { }

    // gerarTokenJWS(): void {
    //     let inputRequest: OAuthInputRequest = {
    //         sessionId: this.nomeSessionId,
    //         jwe: this.nomeJWE,
    //         urlControleBackend: this.urlControleBackend,
    //         origin: this.origin

    //     }
    //     this.httpClient.post<any>(this.urlGeracaoToken, inputRequest)
    //         .subscribe((data: any) => {
    //             this.tokenGerado = data.jwt;
    //             if (data.errorMessage) {
    //                 alert(data.errorMessage);
    //             }
    //         })
    // }

    // realizarChamadaTeste(): void {
    //     let inputRequest: TesteChamadaInputRequest = {
    //         jwt: this.tokenGerado,
    //         urlControleBackend: this.urlControleBackend,
    //         origin: this.originChamadaTeste
    //     }

    //     this.httpClient.post<any>(this.urlChamadaTeste, inputRequest)
    //     .subscribe((data: any) => {
    //         alert(JSON.stringify(data));

    //     })
    // }

}
